/* eslint-disable */

import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import jMoment from 'moment-jalali'
import {Link} from 'react-router-dom'
import RETAIL from '../BaseComponent/RETAIL'
import FromToPicker from '../BaseComponent/FromToPicker'
import $ from 'jquery'
import {guide, speedGuide} from './guide'
import InputMask from 'react-input-mask'
import moment from 'moment-jalali'
import {divIcon} from 'leaflet'
import {renderToStaticMarkup} from 'react-dom/server'
import {Map, Marker, TileLayer, Popup, Polyline} from 'react-leaflet'
class TrajectoryDriver extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      arrayOfPoint: [],
      final: [],
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},

      driverName: '',
      showSearch: 'location',
      showFinalSearch: 'location',
      defaultValueDate: true,
      deliveryPoints: [],
      layerDeliveryPoints: [],
      showDeliveryPoints: 'no',
      showDeliveryFilter: false,
      activeMarkerDelivery: {},
      selectedPlaceDelivery: {},
      showingInfoWindowDelivery: {},
      newLocations: [],
      height: 25,
      width: 20
    }
  }

  loadTrajectoryFromSpeedDriver = (driverId, from, to) => {
    let data = {
      from,
      to,
      driverID: driverId
    }
    http
      .post(`${RETAIL.RETAIL_MANAGE_TRAJECTORY_DRIVER_RANGE}`, data, {})
      .then((response) => {
        if (response.data.error === null) {
          let array = response.data.object
          let newLocations = []
          array.forEach((item) => {
            item.locations.forEach((ch) => {
              ch.state = item.state
              ch.validHour = this.convertDigit(moment(ch.timestamp).format('HH:mm'))
              newLocations.push(ch)
            })
          })
          this.setState({
            newLocations,
            showFinalSearch: this.state.showSearch
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  componentWillMount() {
    $(function() {
      $('.filterComponent').show()
    })
    let urlParams = new URLSearchParams(window.location.search)
    let fromDate = urlParams.get('fromDate') === null ? '' : urlParams.get('fromDate')
    let toDate = urlParams.get('toDate') === null ? '' : urlParams.get('toDate')
    let {driverId} = this.props.match.params
    if (fromDate !== '' && toDate !== '') {
      this.setState({
        defaultValueDate: false,
        fromDate,
        toDate
      })
      this.loadTrajectoryFromSpeedDriver(driverId, fromDate, toDate)
      this.loadDeliveryPackLocation(driverId, fromDate, toDate)
    }
  }

  loadDeliveryPackLocation = (driverId, from, to) => {
    let data = {
      from,
      to,
      driverId
    }
    http.post(`${RETAIL.RETAIL_MANAGE_TRAJECTORY_DRIVER_DELIVERY}`, data, {}).then((res) => {
      if (res.data.error === null) {
        this.setState({
          deliveryPoints: res.data.object
        })
        if (res.data.object.length > 0) {
          this.setState({
            showDeliveryFilter: true
          })
        } else {
          message.error('هیچ پارت تحویلی یافت نشد')
          this.setState({
            showDeliveryFilter: false
          })
        }
      }
    })
  }

  onMarkerClick(props, marker, e) {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  quantity() {
    let quantitymin = Number(document.getElementById('speedMin').value)
    // let quantitymax=Number(document.getElementById('quantitymax').value);
    document.getElementById('speedMax').value = quantitymin + 1
    let quantitymax = document.getElementById('speedMax').value
  }

  searchLocation() {
    var {driverId} = this.props.match.params
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let speedMin = document.getElementById('speedMin').value
    let speedMax = document.getElementById('speedMax').value
    let startHour = document.getElementById('startHour').value
    let endHour = document.getElementById('endHour').value

    if (minDate === '' || maxDate === '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      let data = {
        from: minDate,
        to: maxDate,
        driverID: driverId,
        speedMax: +speedMax !== 0 ? +speedMax : undefined,
        speedMin: +speedMin !== 0 ? +speedMin : undefined
      }
      this.loadDeliveryPackLocation(driverId, minDate, maxDate)
      http
        .post(`${RETAIL.RETAIL_MANAGE_TRAJECTORY_DRIVER_RANGE}`, data, {})
        .then((response) => {
          if (response.data.error === null) {
            this.setState({
              newLocations: [],
              showFinalSearch: this.state.showSearch
            })
            let array = response.data.object
            let newLocations = []
            array.forEach((item) => {
              item.locations.forEach((ch) => {
                ch.state = item.state
                ch.validHour = this.convertDigit(moment(ch.timestamp).format('HH:mm'))
                newLocations.push(ch)
              })
            })
            this.filterLocationByHour(newLocations, startHour, endHour)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  filterLocationByHour = (newLocations, startHour, endHour) => {
    if (startHour !== '' && endHour !== '') {
      let validStartHour = moment(startHour, 'HH:mm')
      let validEndHour = moment(endHour, 'HH:mm')
      let filterdLocations = newLocations.filter((item) =>
        moment(item.validHour, 'HH:mm').isBetween(validStartHour, validEndHour)
      )
      this.setState({
        newLocations: filterdLocations
      })
    } else if (startHour !== '' && endHour === '') {
      let validStartHour = moment(startHour, 'HH:mm')
      let filterdLocations = newLocations.filter((item) => moment(item.validHour, 'HH:mm').isAfter(validStartHour))
      this.setState({
        newLocations: filterdLocations
      })
    } else if (startHour === '' && endHour !== '') {
      let validEndHour = moment(endHour, 'HH:mm')
      let filterdLocations = newLocations.filter((item) => moment(item.validHour, 'HH:mm').isBefore(validEndHour))
      this.setState({
        newLocations: filterdLocations
      })
    } else {
      this.setState({
        newLocations
      })
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  changeColorMarker = (state, hour) => {
    var icon
    if (state === 100) {
      switch (hour) {
        case '00':
        case '01':
        case '02':
        case '03':
        case '04':
        case '05':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/24-06.png')} height={this.state.height} width={this.state.width} />
          )
          break
        case '06':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/06-07.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/06-07.png");
          break
        case '07':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/07-08.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/07-08.png");
          break
        case '08':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/08-09.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/08-09.png");
          break
        case '09':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/09-10.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/09-10.png");
          break
        case '10':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/10-11.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/10-11.png");
          break
        case '11':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/11-12.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/11-12.png");
          break
        case '12':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/12-13.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/12-13.png");
          break
        case '13':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/13-14.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/13-14.png");
          break
        case '14':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/14-15.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/14-15.png");
          break
        case '15':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/15-16.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/15-16.png");
          break
        case '16':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/16-17.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/16-17.png");
          break
        case '17':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/17-18.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/17-18.png");
          break
        case '18':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/18-19.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/18-19.png");
          break
        case '19':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/19-20.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/19-20.png");
          break
        case '20':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/20-21.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/20-21.png");
          break
        case '21':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/21-22.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/21-22.png");
          break
        case '22':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/22-23.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/22-23.png");
          break
        case '23':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-black/23-24.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-black/23-24.png");
          break
        default:
          icon = renderToStaticMarkup(
            <img src={require('../../image/miniLoc.png')} height={this.state.height} width={this.state.width} />
          )
        //   icon = require("../../image/miniLoc.png");
      }
      return icon
    } else {
      switch (hour) {
        case '00':
        case '01':
        case '02':
        case '03':
        case '04':
        case '05':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/24-06.png')} height={this.state.height} width={this.state.width} />
          )
          break
        case '06':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/06-07.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/06-07.png");
          break
        case '07':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/07-08.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/07-08.png");
          break
        case '08':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/08-09.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/08-09.png");
          break
        case '09':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/09-10.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/09-10.png");
          break
        case '10':
          icon = renderToStaticMarkup(
            <img
              src={require('../../pin-white/10-11.png')}
              height={this.state.height}
              width={this.state.width}
              style={{marginBottom: '10px'}}
            />
          )
          //   icon = require("../../pin-white/10-11.png");
          break
        case '11':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/11-12.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/11-12.png");
          break
        case '12':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/12-13.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/12-13.png");
          break
        case '13':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/13-14.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/13-14.png");
          break
        case '14':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/14-15.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/14-15.png");
          break
        case '15':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/15-16.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/15-16.png");
          break
        case '16':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/16-17.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/16-17.png");
          break
        case '17':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/17-18.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/17-18.png");
          break
        case '18':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/18-19.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/18-19.png");
          break
        case '19':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/19-20.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/19-20.png");
          break
        case '20':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/20-21.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/20-21.png");
          break
        case '21':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/21-22.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/21-22.png");
          break
        case '22':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/22-23.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/22-23.png");
          break
        case '23':
          icon = renderToStaticMarkup(
            <img src={require('../../pin-white/23-24.png')} height={this.state.height} width={this.state.width} />
          )
          //   icon = require("../../pin-white/23-24.png");
          break
        default:
          icon = renderToStaticMarkup(
            <img src={require('../../image/miniLoc.png')} height={this.state.height} width={this.state.width} />
          )
        //   icon = require("../../image/miniLoc.png");
      }
      return icon
    }
  }

  changeColorMarkerBySpeed = (state, speed) => {
    var icon
    if (state === 100) {
      if (speed >= 0 && speed <= 60) {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-black/15-16.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-black/15-16.png')
        return icon
      } else if (speed > 60 && speed <= 90) {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-black/17-18.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-black/17-18.png')
        return icon
      } else if (speed > 90 && speed <= 110) {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-black/20-21.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-black/20-21.png')
        return icon
      } else {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-black/24-06.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-black/24-06.png')
        return icon
      }
    } else {
      if (speed >= 0 && speed <= 60) {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-white/15-16.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-white/15-16.png')
        return icon
      } else if (speed > 60 && speed <= 90) {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-white/17-18.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-white/17-18.png')
        return icon
      } else if (speed > 90 && speed <= 110) {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-white/20-21.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-white/20-21.png')
        return icon
      } else {
        icon = renderToStaticMarkup(
          <img src={require('../../pin-white/24-06.png')} height={this.state.height} width={this.state.width} />
        )
        // icon = require('../../pin-white/24-06.png')
        return icon
      }
    }
  }

  submit(e) {
    e.preventDefault()
  }

  showSearchBy = (e) => {
    let name = e.target.name
    this.setState({
      [name]: e.target.value
    })
  }

  toggleShowDeliveryPoints = (e) => {
    let value = e.target.value
    if (value === 'yes') {
      this.setState({
        layerDeliveryPoints: this.state.deliveryPoints,
        showingInfoWindowDelivery: false
      })
    } else {
      this.setState({
        layerDeliveryPoints: [],
        showingInfoWindowDelivery: false
      })
    }
  }

  onMarkerClickDelivery(props, marker, e) {
    this.setState({
      selectedPlaceDelivery: props,
      activeMarkerDelivery: marker,
      showingInfoWindowDelivery: true
    })
  }

  getMarkers() {
    let points = this.state.newLocations
    console.log(points)
    const array = []
    points.forEach((item) => {
      if (item.lat && item.lon) {
        array.push({
          location: [item.lat, item.lon],
          ...item
        })
      }
    })
    return array
  }

  deliveryMarkers() {
    let points = this.state.layerDeliveryPoints
    console.log(points)
    const array = []
    points.forEach((item) => {
      if (item.lat && item.lon) {
        array.push({
          location: [item.lat, item.lon],
          ...item
        })
      }
    })
    return array
  }

  render() {
    let {driverName} = this.props.match.params
    var {newLocations} = this.state
    for (let i = 0; i < newLocations.length; i++) {
      newLocations[i]['lat'] = newLocations[i]['lat']
      newLocations[i]['lng'] = newLocations[i]['lon']
    }
    const unSelected = renderToStaticMarkup(<img src={require('../../image/requestPack.png')} />)
    const style = {
      width: '100%',
      height: '400px',
      margin: 'auto',
      position: 'relative !important'
    }
    return (
      <div className="rtl">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>
              <Link to={'/Drivers'}>رساننده ها</Link>
            </li>
            <li>تاریخچه مسیر {driverName}</li>
          </ul>
          <div className="filterComponent" style={{marginTop: 5, marginBottom: 5}}>
            <div className="filterInputs">
              <FromToPicker
                onChangeFromDate={this.handleChangeFromDate}
                onChangeToDate={this.handleChangeToDate}
                fromLabel="تاریخ از"
                toLabel="تاریخ تا"
                defaulValue={this.state.defaultValueDate}
                fromId="from"
                toId="to"
                sendValue={this.state.fromDate}
              />

              <div className="formComponent">
                <label>سرعت از :‌</label>
                <input
                  type="number"
                  onChange={this.quantity.bind(this)}
                  min={0}
                  className="form-control"
                  id="speedMin"
                />
              </div>
              <div className="formComponent">
                <label>سرعت تا :‌</label>
                <input type="number" min={0} className="form-control" id="speedMax" />
              </div>

              <div className="formComponent">
                <label>ساعت از :‌</label>
                <InputMask
                  autocomplete="off"
                  placeholder="HH:mm"
                  id="startHour"
                  className="form-control"
                  mask="99:99"
                  maskChar={null}
                />
              </div>
              <div className="formComponent">
                <label>ساعت تا :‌</label>
                <InputMask
                  autocomplete="off"
                  placeholder="HH:mm"
                  id="endHour"
                  className="form-control"
                  mask="99:99"
                  maskChar={null}
                />
              </div>

              <div className="formComponent">
                <label> نمایش نتایج بر اساس:</label>
                <select className="form-control" onChange={this.showSearchBy} id="showSearch" name="showSearch">
                  <option value="location">موقعیت</option>
                  <option value="speed">سرعت</option>
                </select>
              </div>

              {this.state.showDeliveryFilter && (
                <div className="formComponent">
                  <label> نمایش نقاط تحویل :</label>
                  <select
                    className="form-control"
                    onChange={this.toggleShowDeliveryPoints}
                    id="showDeliveryPoints"
                    name="showDeliveryPoints"
                  >
                    <option value={'no'}>خیر</option>
                    <option value={'yes'}>بلی</option>
                  </select>
                </div>
              )}

              <div className="filterOption">
                <button className="confirmFilter" onClick={this.searchLocation.bind(this)}>
                  نمایش موقعیت ها
                </button>
              </div>
            </div>
            <div className="filterOption">
              {/*<button className='confirmFilter' onClick={this.filter.bind(this)}>جست و جو</button>*/}
            </div>
          </div>
          <div className="filterComponent">
            {this.state.showFinalSearch === 'location' ? (
              <div className="d-flex">
                {guide.map((item, index) => (
                  <div className="formComponent guide">
                    <p>{item.title}</p>
                    {item.url}
                  </div>
                ))}
              </div>
            ) : (
              <div className="d-flex">
                {speedGuide.map((item, index) => (
                  <div className="formComponent guide">
                    <p>{item.title}</p>
                    {item.url}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="addressMap">
            <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px'}}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {this.getMarkers().map((item, index) => (
                <Marker
                  position={item.location}
                  icon={divIcon({
                    html:
                      this.state.showFinalSearch === 'location'
                        ? this.changeColorMarker(item.state, this.convertDigit(jMoment(item.timestamp).format('HH')))
                        : this.changeColorMarkerBySpeed(
                            item.state,
                            this.convertDigit(jMoment(item.timestamp).format('HH'))
                          )
                  })}
                >
                  <Popup>
                    <div className="text-center">سرعت :‌ {item.speed.toFixed(3) + ' کیلومتر بر ساعت '}</div>
                    <div className="text-center">
                      {item.timestamp && jMoment(item.timestamp).format('jYYYY/jMM/jDD HH:mm')}
                    </div>
                  </Popup>
                </Marker>
              ))}
              {this.state.layerDeliveryPoints.length > 0
                ? this.deliveryMarkers().map((item, index) => (
                    <Marker
                      position={item.location}
                      icon={divIcon({
                        html: unSelected,
                        iconSize: [30, 30],
                        iconAnchor: [10, 38]
                      })}
                    >
                      <Popup>
                        <div className="text-center">
                          <a
                            href={`/baskets?deliveryPackId=${item.deliveryPackId}`}
                            target="_blank"
                            className="small font-weight-bold"
                          >
                            مشاهده پارت تحویل
                          </a>
                        </div>

                        <div className="text-center">
                          سرعت :‌ {item.speed ? item.speed.toFixed(3) : 0 + ' کیلومتر بر ساعت '}
                        </div>
                        <div className="text-center">
                          {item.timestamp && jMoment(item.timestamp).format('jYYYY/jMM/jDD HH:mm')}
                        </div>
                      </Popup>
                    </Marker>
                  ))
                : null}

              <Polyline positions={this.getMarkers()} />
            </Map>
            {/* <Map
                            google={this.props.google}
                            onClick={this.onMapClicked}
                            zoom={11}
                            style={style}
                            initialCenter={{
                                lat: 35.6892,
                                lng: 51.3890
                            }}
                        >
                            {this.state.newLocations.map((marker, index) => (
                                    this.state.showFinalSearch === 'location' ?
                                        <Marker
                                            name={marker.timestamp}
                                            speed={marker.speed !== null ? ((marker.speed).toFixed(3)) : 0}
                                            scaledSize={new this.props.google.maps.Size(15,25)}
                                            icon={{url : this.changeColorMarker(marker.state, this.convertDigit(jMoment(marker.timestamp).format('HH'))),scaledSize : new google.maps.Size(17, 25)}}
                                            key={`marker${index}`}
                                            onClick={this.onMarkerClick.bind(this)}
                                            position={{lat: marker.lat, lng: marker.lon}}
                                            // onClick={() => console.log((this.line))}
                                        />
                                        :
                                        <Marker
                                            name={marker.timestamp}
                                            speed={marker.speed !== null ? ((marker.speed).toFixed(3)) : 0}
                                            scaledSize={new this.props.google.maps.Size(15,25)}
                                            icon={{url : this.changeColorMarkerBySpeed(marker.state, marker.speed),scaledSize : new google.maps.Size(17, 25)}}
                                            key={`marker${index}`}
                                            onClick={this.onMarkerClick.bind(this)}
                                            position={{lat: marker.lat, lng: marker.lon}}
                                            // onClick={() => console.log((this.line))}
                                        />
                            ))}
                            <Polyline
                                path={newLocations}
                                strokeColor="#000"
                                strokeOpacity={0.4}
                                strokeWeight={2}/>
                            <InfoWindow
                                marker={this.state.activeMarker}
                                visible={this.state.showingInfoWindow}>
                                <p className='mapinfoWindow'>{this.state.selectedPlace.name == null ? '-' : jMoment(this.state.selectedPlace.name).format('jYYYY/jMM/jDD HH:mm')}</p>
                                <p className='mapinfoWindow small font-weight-bold'>{'سرعت : '+this.state.selectedPlace.speed + ' کیلومتر بر ساعت '}</p>
                            </InfoWindow>

                            {this.state.layerDeliveryPoints.length > 0 ?  this.state.layerDeliveryPoints.map((d, index) => (
                                <Marker
                                    deliveryPackId={d.deliveryPackId}
                                    scaledSize={new this.props.google.maps.Size(15,25)}
                                    icon={{url: require('../../image/requestPack.png')}}
                                    key={`pointes${index}`}
                                    position={{lat: d.lat, lng: d.lon}}
                                    onClick={this.onMarkerClickDelivery.bind(this)}
                                />
                            ))
                            :
                            null
                            }
                            <InfoWindow
                                marker={this.state.activeMarkerDelivery}
                                visible={this.state.showingInfoWindowDelivery}>
                                <a href={`/baskets?deliveryPackId=${this.state.selectedPlaceDelivery.deliveryPackId}`} target='_blank' className='small font-weight-bold'>مشاهده پارت تحویل</a>
                                {/*<p className='mapinfoWindow small font-weight-bold'>{'سرعت : '+this.state.selectedPlace.speed + ' کیلومتر بر ساعت '}</p>*/}
            {/* </InfoWindow> */}

            {/* </Map> */}
          </div>
        </div>
      </div>
    )
  }
}

export default TrajectoryDriver
